import { FlexColumn, FlexRow, LabeledInput, MaterialIcon, useLoading } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { useMemo, useState } from 'react';
import { FEEDBACK, FEEDBACK_PREFIXES } from '../../constants/app';
import { useFeedback } from '../../hooks/useFeedback';
import { useStyles } from '../../hooks/useStyles';
import { postBrand } from '../../services/vehicleService';
import { Brand } from '../../types/brand';
import StyledTooltip from '../ui/StyledTooltip';

type Props = {
  onCancel: () => void;
  afterSave: () => void;
};
export function BrandForm({ onCancel, afterSave }: Readonly<Props>) {
  const { css } = useStyles();
  const [editingBrand, setEditingBrand] = useState<Brand>({
    _id: '',
    name: '',
  });
  const { startLoading, stopLoading, loading } = useLoading(false);
  const { showFailFeedback, showPositiveFeedback } = useFeedback();

  const canSubmit = useMemo(() => {
    return !!editingBrand.name;
  }, [editingBrand]);

  const onInputChange = (value: string | undefined | null, field: keyof Brand) => {
    setEditingBrand((prev) => ({ ...prev!, [field]: value }));
  };

  const onSave = async () => {
    startLoading();
    const { id, error } = await postBrand(editingBrand);
    if (!error && id) {
      afterSave();
      showPositiveFeedback(FEEDBACK.created(FEEDBACK_PREFIXES.brand));
    } else {
      showFailFeedback(error || FEEDBACK.failedCreation(FEEDBACK_PREFIXES.brand));
    }
    stopLoading();
  };

  return (
    <FlexColumn
      classNames={css({
        justifyContent: 'space-between',
        overflow: 'hidden',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'end',
      })}
    >
      <FlexColumn
        classNames={css({
          overflow: 'auto',
          width: '100%',
          height: '100%',
        })}
      >
        <LabeledInput
          label={`(Nueva Marca) Nombre:`}
          value={editingBrand?.name}
          onChange={(value) => onInputChange(value, 'name')}
          required
        />
      </FlexColumn>
      <FlexRow gap={0}>
        <StyledTooltip
          content={'Cancelar'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={onCancel}
            kind="tertiary"
          >
            <MaterialIcon name={'cancel'} />
          </Button>
        </StyledTooltip>
        <StyledTooltip
          content={'Guardar'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={onSave}
            isLoading={loading}
            disabled={!canSubmit}
            kind="tertiary"
          >
            <MaterialIcon name={'done'} />
          </Button>
        </StyledTooltip>
      </FlexRow>
    </FlexColumn>
  );
}
